module.exports = __webpack_public_path__ + "fonts/UKIJTor.d78fc586.ttf";